import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_8xnfeddwvy: FaireCollectionEntity = {
  token: "pbc_8xnfeddwvy",
  type: "collection",
  name: "woodland",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8a8324d529fd5c969548296c543d12a51403c167c2cc3a2b9d6fa0e9e0fd9966.jpeg",
  itemCount: 23,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.295Z",
    importedBy: "entity-db-import-collections",
  },
};
